import React from 'react'
import {connect} from 'react-redux'
import {string, bool, func, oneOf} from 'prop-types'
import {InputField} from '@agillic/agillic-ui'
import {usernameLabel, onChangeHandler, onKeyDownHandler, isUsernameDisabled, isAutofocus} from '../inputFields.helper'
import {validateUsernameInput} from '../inputFields.validation'
import {updateUsername} from '../../login.actionCreators'
import {language, loginModesList} from '../../helpers/login.data'
import localeData from '../../helpers/login.lang'

const locale = localeData[language]

const Username = ({username, isUsernameDirty, onUpdateUsername, isAuthInProgress, mode, isPasswordPolicyPending, onSubmit, isVisible}) => isVisible && (
  <InputField
    label={usernameLabel}
    value={username}
    onChange={({target}) => onChangeHandler({target, onUpdate: onUpdateUsername})}
    validation={validateUsernameInput({isUsernameDirty})}
    isDisabled={isUsernameDisabled({isAuthInProgress, mode, isPasswordPolicyPending})}
    placeholder={locale.usernamePlaceholder()}
    uniqueID='username'
    onKeyDown={({key}) => onKeyDownHandler({key, onSubmit})}
    autofocus={isAutofocus({mode, field: 'username'})}
  />
)

const mapStateToProps = ({loginReducer}) => ({
  username: loginReducer.username,
  isUsernameDirty: loginReducer.isUsernameDirty,
  isAuthInProgress: loginReducer.isAuthInProgress,
  mode: loginReducer.mode,
  isPasswordPolicyPending: loginReducer.isPasswordPolicyPending
})

const mapDispatchToProps = dispatch => ({
  onUpdateUsername: value => dispatch(updateUsername(value))
})

Username.propTypes = {
  isVisible: bool,
  username: string,
  isUsernameDirty: bool,
  onUpdateUsername: func.isRequired,
  isAuthInProgress: bool,
  mode: oneOf(loginModesList),
  isPasswordPolicyPending: bool,
  onSubmit: func.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(Username)
